import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-invoice-three',
  templateUrl: './invoice-three.component.html',
  styleUrls: ['./invoice-three.component.css']
})
export class InvoiceThreeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
